/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyListQuery
 */
export interface AgencyListQuery {
    /**
     * 
     * @type {string}
     * @memberof AgencyListQuery
     */
    abtaNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyListQuery
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyListQuery
     */
    group?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyListQuery
     */
    showNonEffective?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof AgencyListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {number}
     * @memberof AgencyListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgencyListQuery
     */
    limit?: number | null;
}

export function AgencyListQueryFromJSON(json: any): AgencyListQuery {
    return AgencyListQueryFromJSONTyped(json, false);
}

export function AgencyListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'abtaNumber': !exists(json, 'abtaNumber') ? undefined : json['abtaNumber'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'group': !exists(json, 'group') ? undefined : json['group'],
        'showNonEffective': !exists(json, 'showNonEffective') ? undefined : json['showNonEffective'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function AgencyListQueryToJSON(value?: AgencyListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'abtaNumber': value.abtaNumber,
        'label': value.label,
        'group': value.group,
        'showNonEffective': value.showNonEffective,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'offset': value.offset,
        'limit': value.limit,
    };
}


